import { createMuiTheme, Typography } from '@material-ui/core';
import blueGrey from '@material-ui/core/colors/blueGrey';
import TncIcon from '@material-ui/icons/DirectionsCar';
import EventIcon from '@material-ui/icons/Event';
import AirportIcon from '@material-ui/icons/LocalAirport';
import MarketIcon from '@material-ui/icons/LocationCity';
import GeofenceIcon from '@material-ui/icons/PinDrop';
import SubserviceIcon from '@material-ui/icons/RoomService';
import VenueIcon from '@material-ui/icons/StoreMallDirectory';
import simpleRestClient from 'ra-data-simple-rest';
import React from 'react';
import { Admin, AppBar, fetchUtils, Layout, Resource } from 'react-admin';
import pkg from '../package.json';
import addMixpanel from './addMixpanel';
import { AirportCreate, AirportEdit, AirportList } from './airports';
import './App.css';
import authProvider from './authProvider';
import Dashboard from './dashboard';
import { EventCreate, EventEdit, EventList } from './events';
import { GeofenceCreate, GeofenceEdit, GeofenceList } from './geofences';
import { MarketList } from './markets';
import NotFound from './NotFound';
import {
  SubserviceCreate,
  SubserviceEdit,
  SubserviceList,
} from './subservices';
import { TncCreate, TncEdit, TncList } from './tncs';
import { VenueCreate, VenueEdit, VenueList } from './venues';

let apiUrl = '';
if (process.env.NODE_ENV === 'production') {
  apiUrl = process.env.REACT_APP_PROD_API_URL;
} else {
  apiUrl = process.env.REACT_APP_STAGING_API_URL;
}

const httpClient = (url, options = {}) => {
  options.headers = new Headers({
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${localStorage['token']}`,
  });
  return fetchUtils.fetchJson(url, options);
};

const rClient = simpleRestClient(apiUrl, httpClient);
const trackclient = addMixpanel(rClient);

const theme = createMuiTheme({ palette: { secondary: blueGrey } });

const CustomAppBar = ({ ...props }) => (
  <AppBar {...props}>
    <Typography
      variant="title"
      color="inherit"
      id="react-admin-title"
    ></Typography>
    <span style={{ flex: 1 }} />
    <Typography variant="body1" color="inherit" style={{ marginRight: 8 }}>
      {pkg.version}
    </Typography>
  </AppBar>
);

const CustomLayout = props => <Layout {...props} appBar={CustomAppBar} />;

const App = () => (
  <Admin
    title="Gridwise Console"
    catchall={NotFound}
    authProvider={authProvider}
    dashboard={Dashboard}
    dataProvider={trackclient}
    theme={theme}
    appLayout={CustomLayout}
  >
    <Resource
      name="events"
      list={EventList}
      edit={EventEdit}
      create={EventCreate}
      icon={EventIcon}
    />
    <Resource
      name="markets"
      list={MarketList}
      edit={EventEdit}
      create={EventCreate}
      icon={MarketIcon}
    />
    <Resource
      name="airports"
      list={AirportList}
      edit={AirportEdit}
      create={AirportCreate}
      icon={AirportIcon}
    />
    <Resource
      name="geofences"
      list={GeofenceList}
      edit={GeofenceEdit}
      create={GeofenceCreate}
      icon={GeofenceIcon}
    />
    <Resource
      name="venues"
      list={VenueList}
      edit={VenueEdit}
      create={VenueCreate}
      icon={VenueIcon}
    />
    <Resource
      name="tncs"
      list={TncList}
      edit={TncEdit}
      create={TncCreate}
      icon={TncIcon}
    />
    <Resource
      name="subservices"
      list={SubserviceList}
      edit={SubserviceEdit}
      create={SubserviceCreate}
      icon={SubserviceIcon}
    />
    <Resource name="categories" />
  </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js